import React from 'react';
import cx from 'classnames';
import {withSlotsPlaceholders} from '@wix/widget-plugins-ooi';
import {withExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons';
import sOld from './ProductPageApp-old.scss';
import sNew from './ProductPageApp.scss';
import {LayoutId, LayoutNames} from '../../constants';
import {ProductPageAppProps} from '../../types/app-types';
import {TPAComponentsProvider} from 'wix-ui-tpa';
import {withGlobalProps} from '../../providers/globalPropsProvider';
import '../../styles/app.global.scss';
import {getProductPageSettingsFromProps} from '../../../commons/styleParamsService';
import {EmptyState} from '../Layouts/EmptyState/EmptyState';
import {ClassicLayout} from '../Layouts/ClassicLayout/ClassicLayout';
import {QuickViewLayout} from '../Layouts/QuickViewLayout/QuickViewLayout';
import {ResponsiveLayout} from '../Layouts/ResponsiveLayout/ResponsiveLayout';
import {SimpleLayout} from '../Layouts/SimpleLayout/SimpleLayout';
import {SleekLayout} from '../Layouts/SleekLayout/SleekLayout';
import {SpotlightLayout} from '../Layouts/SpotlightLayout/SpotlightLayout';
import {StunningLayout} from '../Layouts/StunningLayout/StunningLayout';

const layouts = {
  [LayoutId.EmptyState]: EmptyState,
  [LayoutId.Classic]: ClassicLayout,
  [LayoutId.QuickView]: QuickViewLayout,
  [LayoutId.Responsive]: ResponsiveLayout,
  [LayoutId.Simple]: SimpleLayout,
  [LayoutId.Sleek]: SleekLayout,
  [LayoutId.Spotlight]: SpotlightLayout,
  [LayoutId.Stunning]: StunningLayout,
};

export const LayoutContext = React.createContext('');

class ProductPageAppBase extends React.Component<ProductPageAppProps, {s: any}> {
  constructor(props) {
    super(props);
    const {globals} = props;
    /* istanbul ignore next */
    this.state = {s: globals?.experiments?.productPageWithoutGlobalCss ? sNew : sOld};
  }
  public componentDidMount(): void {
    this.props.host.registerToComponentDidLayout(this.reportAppLoaded);
    this.safeRun(this.props.notifyProduct);
  }

  public componentDidUpdate(prevProps: Readonly<ProductPageAppProps>): void {
    if (
      this.props.globals.product &&
      (prevProps.globals.product.id !== this.props.globals.product.id ||
        prevProps.globals.isInteractive !== this.props.globals.isInteractive)
    ) {
      this.safeRun(this.props.notifyProduct);
    }
  }

  private readonly reportAppLoaded = () => {
    this.safeRun(this.props.globals.onAppLoaded);
  };

  private safeRun(fn) {
    if (this.props.globals.isInteractive && typeof fn === 'function') {
      fn();
    }
  }

  public render(): JSX.Element {
    const {s} = this.state;
    const {product, isDesktop, layoutId, isMobile, isRTL, isQuickView, isEditorX} = this.props.globals;
    const fakeUITPAMobileMode = isQuickView; // todo(@nitzansi) make UI TPA accept isNativeSelect in dropdown by force
    const settings = getProductPageSettingsFromProps(this.props);
    const LayoutComp: any = layouts[layoutId];
    const layoutName = LayoutNames[layoutId];
    const layoutClass = `layout__${layoutName}`;
    const classNames = cx(s.ProductPageApp, layoutClass, {
      [s.mobile]: isMobile,
      isDesktop,
      isMobile,
      isQuickView,
      responsive: isEditorX,
    });
    return (
      <TPAComponentsProvider value={{mobile: isMobile || fakeUITPAMobileMode, rtl: isRTL}}>
        <LayoutContext.Provider value={layoutName}>
          <div data-hook="product-page" className={classNames} data-layout-name={layoutName}>
            <LayoutComp
              data-hook="product-layout"
              product={product}
              settings={settings}
              globals={this.props.globals}
              {...this.props}
            />
          </div>
        </LayoutContext.Provider>
      </TPAComponentsProvider>
    );
  }
}

export const ProductPageApp = withGlobalProps(withExpressCheckoutButtons(withSlotsPlaceholders(ProductPageAppBase)));
